






































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ajax from "../../lib/ajax";
import EditMembershipDemand from "./edit-membershipDemand.vue";
import CreateMembershipDemand from "./create-membershipDemand.vue";


export class PagemembershipDemandRequest extends PageRequest {
  membershipId: number;
  tradeType: number | null = null;
  membershipCategory:""
}

@Component({
  components: {
    CreateMembershipDemand,
    EditMembershipDemand
  },
})
export default class membershipDemands extends AbpBase {
  //请求过滤参数
  pagerequest: PagemembershipDemandRequest = new PagemembershipDemandRequest();
  detailShow: boolean = false;
  membershipList: Array<any> = [];
  membershipDemandId: number = null;
  editModalShow: boolean = false;
  createModalShow: boolean = false;

  demandTypeList: Array<any> = [
    {
      label: "卖出",
      value: 1,
    },
    {
      label: "买入",
      value: 0,
    },
  ];
  /**
   * @description:获取所有label和value
   */
  async getAllLabelAndValue() {
    var res = await ajax.get(
      "/api/services/app/Membership/GetAllLabelAndValue"
    );
    this.membershipList = res.data.result;
  }
  edit(row){
    this.membershipDemandId=row.id;
    this.$store.commit("membershipDemand/edit", row);
    this.editModalShow=true;



  }

  create() {
    this.createModalShow = true;
  }
  get list() {
    return this.$store.state.membershipDemand.list;
  }
  get loading() {
    return this.$store.state.membershipDemand.loading;
  }

  pageChange(page: number) {
    this.$store.commit("membershipDemand/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("membershipDemand/setPageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("membershipDemand/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "membershipDemand/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.membershipDemand.pageSize;
  }
  get totalCount() {
    return this.$store.state.membershipDemand.totalCount;
  }
  get currentPage() {
    return this.$store.state.membershipDemand.currentPage;
  }
  columns = [
     {
      title: "会籍种类",
      key: "membershipCategory",
    },
    {
      title: "球场名称",
      minWidth: 120,
      render: (h: any, params: any) => {
        return h("span", params.row.court.name);
      },
    },
    {
      title: "联系人",
      key: "linkMan",
    },
    {
      title: "联系电话",
      key: "phoneNumber",
    },

    {
      title: "意向价格",
      key: "price",
        render: (h: any, params: any) => {
        return h("span", params.row.price+'万');
      },
    },
   
    {
      title: "类型",
      key: "demandType",
      render: (h: any, params: any) => {
        return h("span", params.row.demandType == 0 ? "买入" : "卖出");
      },
    },
    {
      title: "是否发布",
      key: "isPublish",
      render: (h: any, params: any) => {
        return h("span", params.row.isPublish ? "是" : "否");
      },
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.creationTime).toLocaleString());
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 200,
      align: "center",
      slot: "action",
      render: (h, params) => {
        const hasDeletePermission = this.hasPermission(
          "Pages.Membership.Delete"
        );
        const buttons = [];
        if (hasDeletePermission) {
           buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: async () => {
                    this.edit(params.row)
                  
                  },
                },
              },
              "编辑"
            )
          );
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "error",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: async () => {
                    this.$Modal.confirm({
                      title: "提示",
                      content: "确定要删除该记录吗？",
                      okText: "是",
                      cancelText: "否",
                      onOk: async () => {
                        await this.$store.dispatch({
                          type: "membershipDemand/delete",
                          data: params.row,
                        });
                        this.$Message.success("删除成功");
                        await this.getpage();
                      },
                    });
                  },
                },
              },
              "删除"
            )
          );
        }
       
        return h("div", buttons);
      },
    },
  ];
  async created() {
    this.getpage();
  }
}
